export default "__VITE_ASSET__BFhMZ06m__"